var _g, _g2, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardioWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 39,
    r: 34,
    fill: "#08A0A1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 39,
    r: 34,
    fill: "#08A0A1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 40.494 41.944 C 41.06 40.841 41.603 39.9 42.002 38.91 C 42.378 37.972 42.966 37.688 43.981 37.699 C 49.002 37.749 54.022 37.721 59.04 37.721 L 59.534 37.721 C 60.066 37.721 60.524 37.873 60.499 38.466 C 60.476 39.018 60.032 39.133 59.529 39.133 C 55.876 39.133 52.224 39.133 48.572 39.133 C 47.087 39.133 45.602 39.133 44.117 39.133 C 43.932 39.113 43.746 39.155 43.589 39.253 C 43.432 39.35 43.314 39.497 43.255 39.669 C 42.612 40.998 41.965 42.328 41.275 43.627 C 41.088 43.969 40.723 44.377 40.381 44.441 C 39.79 44.548 39.688 43.936 39.532 43.519 C 38.814 41.674 38.118 39.82 37.4 37.972 C 37.355 37.848 37.292 37.732 37.171 37.462 C 37.004 37.773 36.888 37.956 36.803 38.146 C 36.237 39.332 35.672 40.515 35.12 41.713 C 35.047 41.931 34.9 42.118 34.704 42.245 C 34.508 42.372 34.274 42.432 34.04 42.413 C 30.53 42.397 27.017 42.413 23.504 42.413 C 22.989 42.413 22.511 42.325 22.5 41.715 C 22.489 41.106 22.975 41.015 23.49 41.015 C 26.717 41.015 29.947 41.015 33.174 41.015 C 33.381 41.04 33.59 40.993 33.765 40.883 C 33.94 40.773 34.071 40.607 34.133 40.413 C 34.868 38.797 35.621 37.189 36.424 35.602 C 36.585 35.282 36.99 34.863 37.273 34.88 C 37.555 34.896 37.926 35.346 38.062 35.68 C 38.777 37.429 39.428 39.202 40.104 40.965 C 40.194 41.233 40.31 41.503 40.494 41.944 Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 39.588 30.758 C 40.622 29.429 42.044 28.436 43.666 27.909 C 48.669 26.279 53.494 29.721 53.296 34.804 C 53.267 35.239 53.203 35.67 53.106 36.095 C 53.013 36.556 52.742 36.873 52.218 36.766 C 51.695 36.658 51.602 36.277 51.698 35.806 C 51.874 35.065 51.899 34.297 51.77 33.547 C 51.641 32.796 51.361 32.078 50.946 31.434 C 49.249 28.827 45.714 28.154 42.764 29.87 C 41.767 30.449 40.937 31.265 40.352 32.242 C 39.721 33.285 39.266 33.276 38.615 32.214 C 37.892 31.005 36.792 30.053 35.475 29.496 C 34.158 28.938 32.693 28.806 31.294 29.117 C 27.433 30.024 25.835 34.793 28.352 37.91 C 28.7 38.343 29.105 38.738 29.484 39.149 C 29.766 39.471 29.846 39.885 29.47 40.111 C 29.318 40.187 29.149 40.226 28.979 40.226 C 28.808 40.226 28.64 40.187 28.488 40.111 C 27.687 39.493 27.026 38.718 26.549 37.837 C 26.072 36.955 25.788 35.986 25.717 34.992 C 25.645 33.998 25.786 33 26.132 32.062 C 26.478 31.124 27.02 30.267 27.725 29.544 C 30.346 26.899 34.967 26.833 38.072 29.407 C 38.562 29.818 39.034 30.27 39.588 30.758 Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 39.495 49.748 L 45.057 43.846 L 48.309 40.396 C 48.652 40.031 49.033 39.723 49.511 40.147 C 49.989 40.572 49.74 40.975 49.39 41.342 C 46.328 44.587 43.267 47.835 40.207 51.086 C 39.69 51.638 39.297 51.638 38.793 51.086 C 36.701 48.88 34.612 46.665 32.527 44.442 C 32.167 44.058 31.978 43.634 32.442 43.245 C 32.906 42.856 33.265 43.126 33.601 43.482 C 35.287 45.278 36.976 47.072 38.669 48.863 C 38.912 49.142 39.169 49.406 39.495 49.748 Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 28.276 34.627 C 28.277 33.41 28.754 32.239 29.611 31.354 C 30.468 30.469 31.639 29.937 32.885 29.867 C 33.409 29.845 33.884 29.933 33.912 30.529 C 33.937 31.08 33.536 31.226 33.018 31.268 C 31.039 31.419 29.71 32.856 29.724 34.793 C 29.724 35.344 29.936 36.028 29.031 36.094 C 28.513 36.133 28.284 35.689 28.276 34.765 C 28.273 34.719 28.273 34.673 28.276 34.627 Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 3,
    y: 3,
    width: 79,
    height: 79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 0,
    y: 0,
    width: 79,
    height: 79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.792157 0 0 0 0 0.752941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardioWhite);
export default __webpack_public_path__ + "static/media/cardio-white.5c59b8c91c6bd20d3af2ba4edf34712b.svg";
export { ForwardRef as ReactComponent };